import '../../style/base.css';
import '../../info/index.css';
import '../../sticky/index.css';
import '../index.css';